import React, { PureComponent, Fragment } from "react";

import { chooseMove } from "./strategy";
import "../css/Tictactoe/Board.css";

class Board extends PureComponent {
  markWaitGeneration = 0;

  checkColumn = (loc) => {
    switch (loc % 3) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 0:
        return 3;
      default:
        break;
    }
  };

  checkRow = (loc) => {
    switch (Math.ceil(loc / 3)) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 3:
        return 3;
      default:
        break;
    }
  };

  mostLeftBox = (loc) => {
    if (this.checkColumn(loc) === 1) {
      return loc;
    } else {
      return this.mostLeftBox(loc - 1);
    }
  };

  mostTopBox = (loc) => {
    if (this.checkRow(loc) === 1) {
      return loc;
    } else {
      return this.mostTopBox(loc - 3);
    }
  };

  checkVertical = (box, mostTopBox) => {
    if (box[mostTopBox] && box[mostTopBox + 3] && box[mostTopBox + 6]) {
      return (
        box[mostTopBox].type === box[mostTopBox + 3].type &&
        box[mostTopBox + 3].type === box[mostTopBox + 6].type
      );
    }
  };

  checkHorizontal = (box, mostLeftBox) => {
    if (box[mostLeftBox] && box[mostLeftBox + 1] && box[mostLeftBox + 2]) {
      return (
        box[mostLeftBox].type === box[mostLeftBox + 1].type &&
        box[mostLeftBox + 1].type === box[mostLeftBox + 2].type
      );
    }
  };

  checkDiagonal = (box, type, topLeftBox) => {
    switch (type) {
      case "left": {
        if (box[topLeftBox] && box[topLeftBox + 4] && box[topLeftBox + 8]) {
          return (
            box[topLeftBox].type === box[topLeftBox + 4].type &&
            box[topLeftBox + 4].type === box[topLeftBox + 8].type
          );
        }
        break;
      }
      case "right": {
        if (
          box[topLeftBox + 2] &&
          box[topLeftBox + 2 + 2] &&
          box[topLeftBox + 2 + 4]
        ) {
          return (
            box[topLeftBox + 2].type === box[topLeftBox + 2 + 2].type &&
            box[topLeftBox + 2 + 2].type === box[topLeftBox + 2 + 4].type
          );
        }
        break;
      }
      default:
        break;
    }
  };

  checkWinner = (loc, box) => {
    const score = { ...this.props.score };

    const mostTopBox = this.mostTopBox(loc);
    const mostLeftBox = this.mostLeftBox(loc);
    const topLeftBox = this.mostLeftBox(this.mostTopBox(loc));

    // Check is there any streak in same column
    const vertical = this.checkVertical(box, mostTopBox);
    // Check is there any streak in same row
    const horizontal = this.checkHorizontal(box, mostLeftBox);
    // Check is there any streak in diagonal from top left to bottom right
    const leftDiagonal = this.checkDiagonal(box, "left", topLeftBox);
    // Check is there any streak in diagonal from top right to bottom left
    const rightDiagonal = this.checkDiagonal(box, "right", topLeftBox);

    const winLines = [];
    if (horizontal) {
      winLines.push([mostLeftBox, mostLeftBox + 1, mostLeftBox + 2]);
    }
    if (vertical) {
      winLines.push([mostTopBox, mostTopBox + 3, mostTopBox + 6]);
    }
    if (leftDiagonal) {
      winLines.push([topLeftBox, topLeftBox + 4, topLeftBox + 8]);
    }
    if (rightDiagonal) {
      winLines.push([topLeftBox + 2, topLeftBox + 4, topLeftBox + 6]);
    }

    if (winLines.length) {
      const winner = box[loc].type === "circle" ? "O" : "X";
      if (winner === "X") score.firstPlayer += 1;
      else score.secondPlayer += 1;
      return { isFinish: true, score, winner, winLines };
    }
    return { isFinish: false, score };
  };

  locateHorizontal = (isCircle, loc, spot) => {
    const { alpha, beta, gama, omega, teta, delta } = this.props.squarePoint;

    switch (this.checkRow(loc)) {
      case 1:
        isCircle ? (spot.y = alpha) : (spot.y = beta);
        break;
      case 2:
        isCircle ? (spot.y = gama) : (spot.y = omega);
        break;
      case 3:
        isCircle ? (spot.y = teta) : (spot.y = delta);
        break;
      default:
        break;
    }
  };

  locateVertical = (isCircle, loc, spot) => {
    const { alpha, beta, gama, omega, teta, delta } = this.props.squarePoint;

    switch (this.checkColumn(loc)) {
      case 1:
        isCircle ? (spot.x = alpha) : (spot.x = beta);
        break;
      case 2:
        isCircle ? (spot.x = gama) : (spot.x = omega);
        break;
      case 3:
        isCircle ? (spot.x = teta) : (spot.x = delta);
        break;
      default:
        break;
    }
  };

  putCircle = (loc) => {
    let centerSpot = { x: null, y: null };
    this.locateHorizontal(true, loc, centerSpot);
    this.locateVertical(true, loc, centerSpot);

    let r = 55;
    if (window.innerWidth < 768) r = 41.25;
    if (window.innerWidth < 481) r = 27.5;

    return (
      <circle className="circle" cx={centerSpot.x} cy={centerSpot.y} r={r} />
    );
  };

  putCross = (loc) => {
    let topLeftSpot = { x: null, y: null };
    this.locateHorizontal(false, loc, topLeftSpot);
    this.locateVertical(false, loc, topLeftSpot);

    let r = 107;
    if (window.innerWidth < 768) r = 70;
    if (window.innerWidth < 481) r = 50;

    return (
      <path
        className="cross"
        d={`
      M${topLeftSpot.x} ${topLeftSpot.y} ${topLeftSpot.x + r} ${
          topLeftSpot.y + r
        } 
      M${topLeftSpot.x} ${topLeftSpot.y + r} ${topLeftSpot.x + r} ${
          topLeftSpot.y
        }
    `}
      />
    );
  };

  marksFromBoard = (board) => {
    const marks = {};
    for (let i = 1; i <= 9; i++) {
      const cell = board[i];
      marks[i] = !cell ? null : cell.type === "circle" ? "circle" : "cross";
    }
    return marks;
  };

  isBoardFull = (board) => {
    for (let i = 1; i <= 9; i++) if (!board[i]) return false;
    return true;
  };

  actionBotClick = () => {
    if (this.props.isFinish) return;

    const bot = this.props.player === "cross" ? "circle" : "cross";
    const i = chooseMove(this.marksFromBoard(this.props.board), bot);
    if (!i || this.props.board[i]) return;

    this.props.addTurn();

    const box = { ...this.props.board };
    box[i] = bot === "cross" ? this.putCross(i) : this.putCircle(i);

    this.props.updateBoard(box);

    const result = this.checkWinner(i, box);
    if (result.isFinish || this.isBoardFull(box)) {
      this.concludeMove(result);
    }
  };

  actionPlayerClick = (i) => {
    if (this.props.player === "cross" && this.props.turn % 2 === 0) return;
    if (this.props.player === "circle" && this.props.turn % 2 === 1) return;
    if (this.props.board[i] || this.props.isFinish) return;

    this.props.addTurn();

    const box = { ...this.props.board };

    if (this.props.turn % 2 === 0) box[i] = this.putCircle(i);
    else if (this.props.turn % 2 === 1) box[i] = this.putCross(i);

    this.props.updateBoard(box);

    const result = this.checkWinner(i, box);
    if (result.isFinish || this.isBoardFull(box)) {
      this.concludeMove(result);
    } else {
      setTimeout(() => {
        this.actionBotClick();
      }, 500);
    }
  };

  concludeMove = (result) => {
    this.props.finishRound({
      score: result.score,
      winner: result.isFinish ? result.winner : "draw",
      winLines: result.isFinish ? result.winLines : null,
    });
  };

  playAgain = () => {
    this.props.resetGame(this.props.score);
    if (this.props.player === "circle") {
      setTimeout(this.actionBotClick, 500);
    }
  };

  cellCenter = (loc) => {
    const spot = { x: 0, y: 0 };
    this.locateHorizontal(true, loc, spot);
    this.locateVertical(true, loc, spot);
    return spot;
  };

  renderWinLines = () => {
    const { winLines } = this.props;
    if (!winLines) return null;

    return winLines.map((line) => {
      const start = this.cellCenter(line[0]);
      const end = this.cellCenter(line[2]);
      const dx = end.x - start.x;
      const dy = end.y - start.y;
      const length = Math.hypot(dx, dy) || 1;
      const pad = length * 0.21;
      const ux = (dx / length) * pad;
      const uy = (dy / length) * pad;

      return (
        <line
          key={line.join("-")}
          className={this.props.resultReady ? "win-line draw" : "win-line"}
          x1={start.x - ux}
          y1={start.y - uy}
          x2={end.x + ux}
          y2={end.y + uy}
        />
      );
    });
  };

  renderBox = () => {
    const boxes = [];
    for (let i = 1; i <= 9; i++) {
      boxes.push(
        <div
          key={i}
          onClick={this.actionPlayerClick.bind(this, i)}
          className={`box`}
        />
      );
    }
    return boxes;
  };

  renderSvgLine = () => {
    let { alpha, beta, gama, omega } = this.props.linePoint;

    return [
      <line
        className="line"
        key="1"
        x1={alpha}
        y1={beta}
        x2={omega}
        y2={beta}
      />,
      <line
        className="line"
        key="2"
        x1={alpha}
        y1={gama}
        x2={omega}
        y2={gama}
      />,
      <line
        className="line"
        key="3"
        x1={beta}
        y1={alpha}
        x2={beta}
        y2={omega}
      />,
      <line
        className="line"
        key="4"
        x1={gama}
        y1={alpha}
        x2={gama}
        y2={omega}
      />,
    ];
  };

  renderMark = () =>
    Object.keys(this.props.board).map((el, i) => (
      <Fragment key={i}>{this.props.board[el]}</Fragment>
    ));

  resetGame = () => {
    this.props.resetGame({ firstPlayer: 0, secondPlayer: 0 });
  };

  componentDidMount() {
    window.addEventListener("resize", this.resetGame);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resetGame);
    this.cancelWinLineWait();
  }

  cancelWinLineWait = () => {
    this.markWaitGeneration += 1;
    if (this.winLineFrame) cancelAnimationFrame(this.winLineFrame);
    this.winLineFrame = null;
  };

  markIsDrawn = (mark) => {
    const style = getComputedStyle(mark);
    const dash = parseFloat(style.strokeDasharray);
    const offset = parseFloat(style.strokeDashoffset);
    const length = mark.getTotalLength();
    if (!Number.isFinite(dash) || !Number.isFinite(offset) || !length) return false;
    return dash - offset >= length - 1;
  };

  waitForWinningMark = () => {
    const generation = this.markWaitGeneration;
    const started = performance.now();

    const step = () => {
      if (generation !== this.markWaitGeneration || !this.props.winner) return;

      const marks = [
        ...document.querySelectorAll(".svg-board .cross, .svg-board .circle"),
      ];
      const stillDrawing = marks.some((mark) => {
        const anims = mark.getAnimations();
        if (anims.length === 0) return true;
        const running = anims.some((anim) => anim.playState === "running");
        return running && !this.markIsDrawn(mark);
      });

      if ((!stillDrawing && marks.length > 0) || performance.now() - started > 1200) {
        this.props.revealResult();
        return;
      }

      this.winLineFrame = requestAnimationFrame(step);
    };

    this.winLineFrame = requestAnimationFrame(step);
  };

  componentDidUpdate(prevProps) {
    if (
      prevProps.player !== this.props.player &&
      this.props.player === "circle"
    ) {
      setTimeout(() => {
        this.actionBotClick();
      }, 750);
    }

    if (prevProps.winner !== this.props.winner) {
      this.cancelWinLineWait();
      if (this.props.winner) this.waitForWinningMark();
    }
  }

  render() {
    const { winner } = this.props;

    return (
      <div className="board-stage">
        <svg className="svg-board">
          {this.renderSvgLine()}
          {this.renderMark()}
          {this.renderWinLines()}
        </svg>
        <div className="boxes">{this.renderBox()}</div>
        {winner && this.props.resultReady && (
          <div className="win-overlay">
            <p
              className={`win-title ${
                winner === "draw" ? "draw" : winner === "X" ? "x" : "o"
              }`}
            >
              {winner === "draw" ? "Draw" : `${winner} win`}
            </p>
            <button type="button" className="play-again" onClick={this.playAgain}>
              Play Again
            </button>
          </div>
        )}
      </div>
    );
  }
}

export default Board;
